import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';


import { Typography } from '@mui/material';
import Container from 'components/Container';
import Sidebar from '../EcoClub/Sidebar';
import EcoClub2026 from '../EcoClub2026';



const EcoClub6Class2026 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [config, setConfig] = useState({ base_image_url_2026: '' });
  useEffect(() => {
    fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);
  
  const p1 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/ecoclubclass6/1.webp`;
  const p2 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/ecoclubclass6/2.webp`;
  const p3 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/ecoclubclass6/3.webp`;
  const p4 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/ecoclubclass6/4.webp`;
  const p5 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/ecoclubclass6/5.webp`;


  const photos = [
    {
        src: p1,
        source: p1,
        rows: 1,
        cols: 1,
    },
    {
        src: p2,
        source: p2,
        rows: 1,
        cols: 1,
    },
    {
        src: p3,
        source: p3,
        rows: 1,
        cols: 1,
    },
    {
        src: p4,
        source: p4,
        rows: 1,
        cols: 1,
    },
    {
        src: p5,
        source: p5,
        rows: 1,
        cols: 1,
    }

  ];

  return (
    <Main>
   
<Container>

  <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
    <Box>
        
      <Box >
      <Typography variant='h4' align='center' >
      Plant a Seed
        </Typography>
        <Typography
        fontSize = "x-small"
        ><br/><br/>
      Class: 6  &  Date: 13 June 2026
        </Typography>
        {/* <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
"Time spent among trees is never time wasted. Let’s embark on a Journey into Nature"

        <br/>
        </Typography> */}
        <br />
        <Typography variant={'subtitle1'} align={'justify'}>
        As part of the Eco Club`s initiative, the students of Class 6 enthusiastically participated in the <strong>‘Eco Pen Making’</strong> activity under the theme <strong>‘Write Green, Grow Green – Promoting Sustainability Through Eco-Friendly Innovation’</strong>. The activity aimed at raising awareness about environmental conservation by encouraging students to create eco-friendly pens using recycled and biodegradable materials.
      As part of the Eco Club initiative, Class 6 students enthusiastically participated
in the activity <strong>"Plant a Seed"</strong> under the theme <strong>"Adopt Healthy Food
Practices."</strong> The objective of the activity was to create awareness about healthy
eating habits and encourage students to understand the importance of
growing their own food.
      <br></br>
            Students planted seeds of various vegetables and herbs in pots and recycled
            containers. Through this hands-on activity, they learned about the process of
            germination, plant care, and the benefits of consuming fresh, home-grown
            produce. The activity also helped foster a sense of responsibility towards
            nature and sustainable living.
        <br></br>
            The students showed great enthusiasm and commitment, making the activity
            both educational and enjoyable. It was a meaningful step towards promoting
            healthy food choices and environmental consciousness among young learners.
        <br></br>
        </Typography>
      </Box>
      <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
       "Every seed we plant reminds us that good health grows from mindful choices."

<br/>
        </Typography>

      <Box>
        <ImageList
          variant="quilted"
          cols={2}
          rowHeight={isMd ? 300 : 200}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              />
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
    </Grid>

    <Grid item xs={12} md={4}>
             
             <Box marginBottom={4}>
               <EcoClub2026   />
             </Box>
             <Box marginBottom={4}>
               <Sidebar />
             </Box>


    </Grid>
    </Grid> 
    </Container>
    </Main>
   
   
  );
};

export default EcoClub6Class2026;